export const SELECT_PRODUCT = 'SELECT_PRODUCT'
export const CHOOSE_OTHER_PRODUCT = 'CHOOSE_OTHER_PRODUCT'
export const SELECT_PLACE = 'SELECT_PLACE'
export const DELETE_PLACE = 'DELETE_PLACE'
export const NAVIGATE_IN_CATEGORY = 'NAVIGATE_IN_CATEGORY'
export const NAVIGATE_BACK_CATEGORIES = 'NAVIGATE_BACK_CATEGORIES'
export const LOAD_PRODUCTS = 'LOAD_PRODUCTS'
export const RECEIVE_PRODUCTS = 'RECEIVE_PRODUCTS'
export const RECEIVE_STORES = 'RECEIVE_STORES'
export const SELECT_STORE = 'SELECT_STORE'
